/* 🤖 this file was generated by svg-to-ts */
export const matIconVerticalAlignBottom: {
  name: 'vertical-align-bottom';
  data: string;
} = {
  name: 'vertical-align-bottom',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M16 13h-3V3h-2v10H8l4 4 4-4zM4 19v2h16v-2H4z"/></svg>`
};
